"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenValueSchema = exports.EntitlementTokenValueSchema = void 0;
var zod_1 = require("zod");
exports.EntitlementTokenValueSchema = zod_1.z.union([zod_1.z.string().nonempty(), zod_1.z.null()]);
exports.TokenValueSchema = zod_1.z.union([exports.EntitlementTokenValueSchema, zod_1.z.boolean()]);
//# sourceMappingURL=token-value.js.map